export default __webpack_public_path__ + "static/media/tottenham2.cb0f8836.jpg";